<script setup lang="ts">
const { t } = useI18n()
const items = [
    {
        name: t("partials.reviews.review1.name"),
        review: t("partials.reviews.review1.review")
    },
    {
        name: t("partials.reviews.review2.name"),
        review: t("partials.reviews.review2.review")
    },
    {
        name: t("partials.reviews.review3.name"),
        review: t("partials.reviews.review3.review")
    },
]
</script>

<template>
    <UContainer>
        <UCarousel v-slot="{ item }" :items="items" :loop="true" :arrows="true" :dots="true" :autoplay="{ delay: 6000 }" prevIcon="i-lyra-guides-review-arrow-red-prev" nextIcon="i-lyra-guides-review-arrow-red-next" class="review-carousel w-full mx-auto">
            <div class="relative pt-[50px] lg:pt-[90px] cursor-grab select-none">
                <NuxtImg src="/images/partials/review-pin.svg" alt="Pin" class="h-[100px] lg:h-[178px] w-auto -mb-8 lg:-mb-24 absolute left-[50%] top-0 -translate-x-1/2 z-1" />
                <div class="review-shape bg-[#F9D9D7] flex flex-col items-center justify-center gap-4.5 pt-16 lg:pt-32 pb-12 px-10 lg:px-32 overflow-visible">
                    <p class="text-center text-[16px] lg:text-[26px]">{{ item.review }}</p>
                    <span class="uppercase text-[#F46C62] font-bold text-[16px] lg:text-[20px]">{{ item.name }}</span>
                </div>
            </div>
        </UCarousel>
    </UContainer>
    <svg width="0" height="0" style="position:absolute">
        <defs>
            <clipPath id="review-shape" clipPathUnits="objectBoundingBox">
                <path d="
        M0.0595 0
        L0.9406 0
        C0.9761 0 1.0036 0.0926 0.9996 0.1983
        L0.975 0.8422
        C0.9716 0.9321 0.9462 1 0.916 1
        L0.1159 1
        C0.089 1 0.0653 0.9455 0.0585 0.8672
        L0.002 0.2234
        C-0.0079 0.1105 0.0205 0 0.0595 0
        Z" />
            </clipPath>
        </defs>
    </svg>
    <svg width="0" height="0" style="position:absolute">
        <defs>
            <clipPath id="review-shape-mobile" clipPathUnits="objectBoundingBox">
                <path d="
        M0.1485 0
        L0.8515 0
        C0.9357 0 1.003 0.0672 0.9999 0.1481
        L0.9728 0.8624
        C0.9699 0.9392 0.9043 1 0.8244 1
        L0.2108 1
        C0.1336 1 0.0693 0.9431 0.0628 0.8691
        L0.0005 0.1548
        C-0.0067 0.0715 0.0616 0 0.1485 0
        Z" />
            </clipPath>
        </defs>
    </svg>

</template>

<style>
.review-shape {
    aspect-ratio: 3;
    clip-path: url(#review-shape);
    @media (max-width: 1023px) {
        aspect-ratio: 1;
        clip-path: url(#review-shape-mobile);
    }
}
.review-carousel {
    @media (max-width: 639px) {
        .carousel-arrows button {
            bottom: -20px !important;
            top: unset !important;
            font-size: 20px !important;
        }
    }
}
</style>
